
import { Button, IconButton, Popover, SelectChangeEvent, Stack, Typography } from "@mui/material"
import ConfigWrapper from "../widget/ConfigWrapper"
import RemoveOutlinedIcon from "@mui/icons-material/RemoveOutlined";
import AddFilterButton, { CustomRadio, FeatureDropDown, FeaturesCheckbox, FlexInputLabel, NumberInput } from "../widget/FearturesInputTypes/FeatureInputs"
import dropDownPreviewImage from "./static/images/dropdown-catalogue-preview.png";
import tabviewPreviewImage from "./static/images/tabview-preview.png";
import ImageIcon from "@mui/icons-material/Image";
import similarProductGroup from "./static/images/similar-product-preview.png";
import { openPopup } from "../../../../../stateManagement/actions/popupActions";
import similarProductGroupNo from "./static/images/product-grouping-no-preview.png";
import ReloadButton from "../../../mandatoryConfigs/uiThemeConfig/widgets/reloadButton";
import { useContext, useEffect, useState } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { PlaygroundConfigValueContext } from "../../../../../components/newPortal/NewPortalLayout";
import Input,{ CameraImage, DashboardToggleSwitch } from "../../../../../components/Input/Input";
import { getClientConfigFilters } from "../../../../../services/uiConfigService";

interface Props{
    name:string,
    values:any,
setValues: React.Dispatch<React.SetStateAction<any>>;

}
export const CatalogueConfigCustomFilter=(props:Props)=>{
    
   
  
const [filterTypePreview, setFilterTypePreview] = useState<boolean>(true);
const [hasActiveChild, setHasActiveChild] = useState(true);
const [visibelPreviewImg, setVisiblePreviewImg] = useState<boolean>(false);
 const [image, setImage] = useState();
const [removeConfigList,setRemoveConfigList] = useState<string[]>(
    []
  );
  const [maxAllowedDigits, setMaxAllowedDigits] = useState<number>(
      props.values?.maxAllowedDigitForOrder?.value
    );
    const [currImage,setCurrImage] = useState<string | undefined>(
        "https://d2nvw4ekms3xzy.cloudfront.net/salind/images/admin_1726127589190_1726127589189-JUmJMJHwFljP.png"
      );
  const [thirdFilter, setthirdFilter] = useState<boolean>(false);
  const [secondFilter, setsecondFilter] = useState<boolean>(false);
  const [skuCodeValueOne, setSkuCodeValueOne] = useState<string>("");
  const [validationFailiure, setValidationFailiure] = useState<boolean>(false);
   const [error, setErrorDisplay] = useState<boolean>(false);
    const [skuCodeValueTwo, setSkuCodeValueTwo] = useState<string>("");
    const [skuImageCatagory, setSkuImageCatagory] = useState<string>();
const [filterValues, setFilterValues] = useState({
    filter1: "",
    filter2: "",
    filter3: "",
    isValueUpdated:false,
});
 function handlePlaygroundConfig(url: string) {
    props.setValues({
      ...props.values,
      defaultCatalogueImage: {
        ...props.values?.defaultCatalogueImage,
        value: url,
        isValueUpdated: true,
        domainType: "catalogue_configuration",
      },
    });

    // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
    //   {
    //     ...values,
    //     defaultCatalogueImage: {
    //       ...values?.defaultCatalogueImage,
    //       value: url,
    //     },
    //   },
    //   catalogueConfig,
    //   defaultCatalogueInputValues
    // );
    // setPlayGroundConfiguration(convertedVals);
  }
  const handleFilterDelete = (filterName: string) => {
    setFilterValues((prevValues) => {
      const newValues = { ...prevValues };

      if (filterName === "filter1") {
        newValues.filter1 = newValues.filter2;
        newValues.filter2 = newValues.filter3;
        newValues.filter3 = "none";
        setsecondFilter(false);
        setthirdFilter(false);
      } else if (filterName === "filter2") {
        newValues.filter2 = newValues.filter3;
        newValues.filter3 = "none";
        setsecondFilter(false);
        setthirdFilter(false);
      } else if (filterName === "filter3") {
        newValues.filter3 = "none";
        setthirdFilter(false);
      }

      return newValues;
    });
  };
  const getSkuCodeValueTwoToSave = (val: string) => {
    if (val === "first") {
      return "front";
    } else {
      return val;
    }
  };
  
  const handleFilterConditionCheck = (e: SelectChangeEvent<unknown>) => {
      const keyName = e.target.name;
      setSkuCodeValueTwo(e.target.value as string);
      if (skuCodeValueOne !== "" && e.target.value !== "") {
        const value = skuCodeValueOne + " " + getSkuCodeValueTwoToSave(e.target.value as string);
        props.setValues({
          ...props.values,
          [keyName]: {
            ...props.values[keyName],
            value: value,
            isValueUpdated: true,
            domainType: "catalogue_configuration",
          },
        });
        setSkuCodeValueOne(skuCodeValueOne);
        // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
        //   {
        //     ...values,
        //     [keyName]: {
        //       ...values[keyName],
        //       value: value,
        //       isValueUpdated: true,
        //       domainType: "catalogue_configuration",
        //     },
        //   },
        //   catalogueConfig,
        //   defaultCatalogueInputValues
        // );
        // setPlayGroundConfiguration(convertedVals);
      }
    };
  
   const handleRadioChange = (e: SelectChangeEvent<unknown>) => {
      const { name, value } = e.target;
      const newValue = value === "true";
  
      props.setValues((prevValues:any) => ({
        ...prevValues,
        [name]: {
          ...prevValues[name],
          value: newValue,
          isValueUpdated: true,
          domainType: "catalogue_configuration",
        },
      }));
      // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
      //   {
      //     ...values,
      //     [name]: {
      //       ...values[name],
      //       value: newValue,
      //       isValueUpdated: true,
      //       domainType: "catalogue_configuration",
      //     },
      //   },
      //   catalogueConfig,
      //   defaultCatalogueInputValues
      // );
      // setPlayGroundConfiguration(convertedVals);
    };
   const handleFilterAdd = () => {
    if (filterValues.filter1 !== "none") {
      setsecondFilter(true);
      if (filterValues.filter2 !== "none") {
      } else if (filterValues.filter2 === "none") {
        setFilterValues({
          ...filterValues,
          filter2: filteredOptionsLevel2[0].value,
        });
      }
    }
    if (filterValues.filter2 !== "none") {
      setthirdFilter(true);
      if (filterValues.filter3 !== "none") {
      } else if (filterValues.filter3 === "none") {
        setFilterValues({
          ...filterValues,
          filter3: filteredOptionsLevel3[0].value,
        });
      }
    }
  };
    const [dummyImageOptions] = useState([
      {
        value:
          "https://d2nvw4ekms3xzy.cloudfront.net/salind/images/admin_1726127589190_1726127589189-JUmJMJHwFljP.png",
        title: "Beverages",
      },
      {
        value:
          "https://d2nvw4ekms3xzy.cloudfront.net/salind/images/admin_1726127465117_1726127465116-APWNasRoQAJm.png",
        title: "Snacks",
      },
      {
        value:
          "https://d2nvw4ekms3xzy.cloudfront.net/salind/images/admin_1726127513316_1726127513316-iJPpCSrHcSRq.png",
        title: "Confectionary",
      },
      {
        value:
          "https://d2nvw4ekms3xzy.cloudfront.net/salind/images/admin_1726127589190_1726127589189-JUmJMJHwFljP.png",
        title: "Stationary",
      },
      {
        value:
          "https://d2nvw4ekms3xzy.cloudfront.net/salind/images/admin_1726127557972_1726127557971-CDhyrybWbrON.png",
        title: "Health & Wellness",
      },
      {
        value:
          "https://d2nvw4ekms3xzy.cloudfront.net/salind/images/admin_1726127589190_1726127589189-JUmJMJHwFljP.png",
        title: "Personal Care & Hygiene",
      },
    ]);
      function handleRemoveFunction() {
    setImage(undefined);
    setCurrImage(undefined);
    setSkuImageCatagory("");
  }
    const [labelCheckValueMapping, setLabelCheckValueMapping] = useState({
      caseLabel: {
        isChecked: props.values?.caseUnitLabel?.loadedFromApi === true,
        value: props.values?.caseUnitLabel?.loadedFromApi === true ? props.values?.caseUnitLabel?.value : props.values?.focCaseUnitLabel?.value,
      },
      packLabel: {
        isChecked: props.values?.packUnitLabel?.loadedFromApi === true,
        value: props.values?.packUnitLabel?.loadedFromApi === true ? props.values?.packUnitLabel?.value : props.values?.focPackUnitLabel?.value,
      },
      otherLabel: {
        isChecked: props.values?.otherUnitLabel?.loadedFromApi === true,
        value: props.values?.otherUnitLabel?.loadedFromApi === true ? props.values?.otherUnitLabel?.value : props.values?.focOtherUnitLabel?.value,
      },
    });
  
 const [filterOptions, setFilterOptions] = useState([
    { value: "category", title: "Category" },
    { value: "brand", title: "Brand" },
    { value: "pieceSize", title: "Pack size" },
    { value: "subCategory", title: "Sub category" },
    { value: "flavour", title: "Flavour" },
  ]);
    const filteredOptionsLevel1 = filterOptions.filter(
    (option) =>
      option.value !== filterValues.filter2 &&
      option.value !== filterValues.filter3
  );

  const filteredOptionsLevel2 = filterOptions.filter(
    (option) =>
      option.value !== filterValues.filter1 &&
      option.value !== filterValues.filter3
  );

  const filteredOptionsLevel3 = filterOptions.filter(
    (option) =>
      option.value !== filterValues.filter2 &&
      option.value !== filterValues.filter1
  );
  const handleValueChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (e.target.max && e.target.value.length > parseInt(e.target.max)) return;
      if (e.target.min && e.target.value.length < parseInt(e.target.min)) {
        setValidationFailiure(true);
        setErrorDisplay(true);
      } else {
        setValidationFailiure(false);
        setErrorDisplay(false);
      }
      const { name, value } = e.target;
      const keyName = name;
      const newValue = value.toString();
  
      // Update the state
      props.setValues((prevValues:any) => ({
        ...prevValues,
        [keyName]: {
          ...prevValues[keyName],
          value: newValue,
          isValueUpdated: true,
          domainType: "catalogue_configuration",
        },
      }));
      // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
      //   {
      //     ...values,
      //     [keyName]: {
      //       ...values[keyName],
      //       value: newValue,
      //       isValueUpdated: true,
      //       domainType: "catalogue_configuration",
      //     },
      //   },
      //   catalogueConfig,
      //   defaultCatalogueInputValues
      // );
      // setPlayGroundConfiguration(convertedVals);
    };
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
     const [infoClick, setInfoClick] = useState<boolean>(false);
const handleInfoIconClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setInfoClick(!infoClick);
  };
  const handleValueChange = (
      e: React.ChangeEvent<HTMLInputElement>,
      newValue: number
    ) => {
      const keyName = e.target.name;
  
      if (keyName === "maxAllowedDigitForOrder") {
        if (newValue > 4) {
          openPopup("Error", "You can select up to 4 digits for order");
          return;
        }
  
        props.setValues((prevValues:any) => ({
          ...prevValues,
          [keyName]: {
            ...prevValues[keyName],
            value: newValue,
            isValueUpdated: true,
            domainType: "catalogue_configuration",
          },
        }));
        // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
        //   {
        //     ...values,
        //     [keyName]: {
        //       ...values[keyName],
        //       value: newValue,
        //       isValueUpdated: true,
        //       domainType: "catalogue_configuration",
        //     },
        //   },
        //   catalogueConfig,
        //   defaultCatalogueInputValues
        // );
        // setPlayGroundConfiguration(convertedVals);
      } else if (keyName === "skuCodeConditionOne") {
        if (newValue < 0) {
          openPopup("Error", "You can't set a value less than 0");
          return;
        }
        if (newValue >= 7) {
          openPopup("Error", "You can't set a value more than 6");
        }
  
        setSkuCodeValueOne(newValue.toString());
        props.setValues((prevValues:any) => ({
          ...prevValues,
          skuCodeCondition: {
            ...prevValues["skuCodeCondition"],
            value: `${newValue} ${getSkuCodeValueTwoToSave(skuCodeValueTwo)}`,
            isValueUpdated: true,
            domainType: "catalogue_configuration",
          },
        }));
        // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
        //   {
        //     ...values,
        //     ["skuCodeCondition"]: {
        //       ...values["skuCodeCondition"],
        //       value: `${newValue} ${skuCodeValueTwo}`,
        //       isValueUpdated: true,
        //       domainType: "catalogue_configuration",
        //     },
        //   },
        //   catalogueConfig,
        //   defaultCatalogueInputValues
        // );
        // setPlayGroundConfiguration(convertedVals);
      } else {
        props.setValues((prevValues:any) => ({
          ...prevValues,
          [keyName]: {
            ...prevValues[keyName],
            value: newValue,
            isValueUpdated: true,
            domainType: "catalogue_configuration",
          },
        }));
        // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
        //   {
        //     ...values,
        //     [keyName]: {
        //       ...values[keyName],
        //       value: newValue,
        //       isValueUpdated: true,
        //       domainType: "catalogue_configuration",
        //     },
        //   },
        //   catalogueConfig,
        //   defaultCatalogueInputValues
        // );
        // setPlayGroundConfiguration(convertedVals);
      }
    };
     const handleMaximumAllowedDigitIncrement = () => {
    const updatevalue = maxAllowedDigits + 1;
    props.setValues({
      ...props.values,
      maxAllowedDigitForOrder: {
        ...props.values?.maxAllowedDigitForOrder,
        value: updatevalue,
        isValueUpdated: true,
        domainType: "catalogue_configuration",
      },
    });
    setMaxAllowedDigits((prev) => prev + 1);
    // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
    //   {
    //     ...values,
    //     ["maxAllowedDigitForOrder"]: {
    //       ...values["maxAllowedDigitForOrder"],
    //       value: updatevalue,
    //       isValueUpdated: true,
    //       domainType: "catalogue_configuration",
    //     },
    //   },
    //   catalogueConfig,
    //   defaultCatalogueInputValues
    // );
    // setPlayGroundConfiguration(convertedVals);
  };
    const handleLabelValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (
        e.target.value.match("^[a-zA-Z ]*$") == null &&
        e.target.type !== "number"
      ) {
        return;
      }
      if (e.target.type === "number") {
        const digit = e.target.value === "" ? 0 : Number(e.target.value);
        if (digit < 0) {
          openPopup("Error", "Cannot set a negative value");
          return;
        }
      }
  
      const keyName = e.target.name;
      if (keyName === "maxAllowedDigitForOrder") {
        const digit = e.target.value === "" ? 0 : Number(e.target.value); // Use Number to convert value
        if (digit > 4) {
          openPopup("Error", "You can select Upto 4 digits for order");
          return;
        }
      }
      props.setValues({
        ...props.values,
        [keyName]: {
          ...props.values[keyName],
          value: e.target.value,
          isValueUpdated: true,
          domainType: "catalogue_configuration",
        },
      });
      // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
      //   {
      //     ...values,
      //     [keyName]: {
      //       ...values[keyName],
      //       value: e.target.value,
      //       isValueUpdated: true,
      //       domainType: "catalogue_configuration",
      //     },
      //   },
      //   catalogueConfig,
      //   defaultCatalogueInputValues
      // );
      // setPlayGroundConfiguration(convertedVals);
    };
    const handleLabelCheckChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const labelToConfigMapping: Record<
          string,
          { checked: string; unChecked: string } | undefined
        > = {
          caseLabel: {
            checked: "caseUnitLabel",
            unChecked: "focCaseUnitLabel",
          },
          packLabel: {
            checked: "packUnitLabel",
            unChecked: "focPackUnitLabel",
          },
          otherLabel: {
            checked: "otherUnitLabel",
            unChecked: "focOtherUnitLabel",
          },
        };
    
        const labelName = e.target.name as "caseLabel" | "packLabel" | "otherLabel";
        const isChecked = e.target.checked;
    
        const configMapping = labelToConfigMapping[labelName];
    
        if (configMapping) {
          props.setValues((prev:any) => {
            const checkedConfig = configMapping.checked;
            const unCheckedConfig = configMapping.unChecked;
    
            if (isChecked) {
              setRemoveConfigList((prevList) => {
                const updatedList = prevList.filter((config) => config !== checkedConfig);
                if (!updatedList.includes(unCheckedConfig)) {
                  updatedList.push(unCheckedConfig);
                }
                return updatedList;
              });
              prev[checkedConfig] = {
                ...prev[checkedConfig],
                value: labelCheckValueMapping[labelName].value,
                isValueUpdated: true,
                domainType: "catalogue_configuration",
                loadedFromApi: true
              };
              if (unCheckedConfig) {
                prev[unCheckedConfig] = {
                  ...prev[unCheckedConfig],
                  value: "null",
                  isValueUpdated: true,
                  domainType: "catalogue_configuration",
                  loadedFromApi: false
                };
              }
            } else {
              setRemoveConfigList((prevList) => {
                const updatedList = prevList.filter((config) => config !== unCheckedConfig);
                if (!updatedList.includes(checkedConfig)) {
                  updatedList.push(checkedConfig);
                }
                return updatedList;
              });
              if (unCheckedConfig) {
                prev[unCheckedConfig] = {
                  ...prev[unCheckedConfig],
                  value: labelCheckValueMapping[labelName].value,
                  isValueUpdated: true,
                  domainType: "catalogue_configuration",
                  loadedFromApi: true
                };
              }
              prev[checkedConfig] = {
                ...prev[checkedConfig],
                value: "null",
                isValueUpdated: true,
                domainType: "catalogue_configuration",
                loadedFromApi: false
              };
            }
    
            return { ...prev };
          });
    
          // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
          //   values,
          //   catalogueConfig,
          //   defaultCatalogueInputValues
          // );
          // setPlayGroundConfiguration(convertedVals);
        }
      };
       const handlePreviewVisibility = () => {
    setVisiblePreviewImg(!visibelPreviewImg);
  };
    const open = Boolean(anchorEl);
      const handleMaximumAllowedDigitDecrement = () => {
    const updatevalue = maxAllowedDigits - 1;
    props.setValues({
      ...props.values,
      maxAllowedDigitForOrder: {
        ...props.values?.maxAllowedDigitForOrder,
        value: updatevalue,
        isValueUpdated: true,
        domainType: "catalogue_configuration",
      },
    });
    setMaxAllowedDigits((prev) => prev - 1);
    // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
    //   {
    //     ...values,
    //     ["maxAllowedDigitForOrder"]: {
    //       ...values["maxAllowedDigitForOrder"],
    //       value: updatevalue,
    //       isValueUpdated: true,
    //       domainType: "catalogue_configuration",
    //     },
    //   },
    //   catalogueConfig,
    //   defaultCatalogueInputValues
    // );
    // setPlayGroundConfiguration(convertedVals);
  }
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const handleDummyImageChange = (e: SelectChangeEvent<unknown>) => {
      setSkuImageCatagory(e.target.value as string);
  
      setCurrImage(
        dummyImageOptions.filter(
          (dummyImage) => dummyImage.title === e.target.value
        )[0].value
      );
      handlePlaygroundConfig(
        dummyImageOptions.filter(
          (dummyImage) => dummyImage.title === e.target.value
        )[0].value
      );
    };
    const handleSelectValueChange = (e: SelectChangeEvent<unknown>) => {
      const { name, value } = e.target;
  
      let parsedValue: boolean | string;
  
      if (value === "true") {
        parsedValue = true;
      } else if (value === "false") {
        parsedValue = false;
      } else {
        parsedValue = value as string;
      }
  
      props.setValues((prevValues:any) => ({
        ...prevValues,
        [name]: {
          ...prevValues[name],
          value: parsedValue,
          isValueUpdated: true,
          domainType: "catalogue_configuration",
        },
      }));

      // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
      //   {
      //     ...values,
      //     [name]: {
      //       ...values[name],
      //       value: parsedValue,
      //       isValueUpdated: true,
      //       domainType: "catalogue_configuration",
      //     },
      //   },
      //   catalogueConfig,
      //   defaultCatalogueInputValues
      // );
      // setPlayGroundConfiguration(convertedVals);
    };
    const handleLabelUOMValueChange = (
        e: React.ChangeEvent<HTMLInputElement>
      ) => {
        const labelToConfigMapping: Record<
          string,
          { checked: string; unChecked?: string; ptrConfig: string } | undefined
        > = {
          caseLabel: {
            checked: "caseUnitLabel",
            unChecked: "focCaseUnitLabel",
            ptrConfig: "casePtrLabel",
          },
          packLabel: {
            checked: "packUnitLabel",
            unChecked: "focPackUnitLabel",
            ptrConfig: "packPtrLabel",
          },
          otherLabel: {
            checked: "otherUnitLabel",
            unChecked: "focOtherUnitLabel",
            ptrConfig: "otherPtrLabel",
          },
        };
    
        const labelName = e.target.name as "caseLabel" | "packLabel" | "otherLabel";
        const value = e.target.value;
    
        if (
          e.target.value.match("^[a-zA-Z ]*$") == null &&
          e.target.type !== "number"
        ) {
          return;
        }
        if (e.target.type === "number") {
          const digit = e.target.value === "" ? 0 : Number(e.target.value);
          if (digit < 0) {
            openPopup("Error", "Cannot set a negative value");
            return;
          }
        }
    
        const configMapping = labelToConfigMapping[labelName];
    
        if (configMapping) {
          props.setValues((prev:any) => {
            const checkedConfig = configMapping.checked;
            const unCheckedConfig = configMapping.unChecked;
            const ptrConfig = configMapping.ptrConfig;
    
            if (labelCheckValueMapping[labelName].isChecked) {
              prev[checkedConfig] = {
                ...prev[checkedConfig],
                value,
                isValueUpdated: true,
                domainType: "catalogue_configuration",
              };
            } else {
              if (unCheckedConfig) {
                prev[unCheckedConfig] = {
                  ...prev[unCheckedConfig],
                  value,
                  isValueUpdated: true,
                  domainType: "catalogue_configuration",
                };
              }
            }
    
            prev[ptrConfig] = {
              ...prev[ptrConfig],
              value: `per ${value}`,
              isValueUpdated: true,
              domainType: "catalogue_configuration",
            };
    
            return { ...prev };
          });
    
          // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
          //   values,
          //   catalogueConfig,
          //   defaultCatalogueInputValues
          // );
          // setPlayGroundConfiguration(convertedVals);
        }
      };

      const handleFilterValueChange = (e: SelectChangeEvent<any>) => {
        if (e.target.name === "filter1" && filterValues.filter1 === "none") {
          setFilterValues({
            ...filterValues,
            filter1: e.target.value,
            isValueUpdated:true,
          });
        } else if (e.target.name === "filter2" && filterValues.filter1 === "none") {
          setFilterValues({
            ...filterValues,
            filter1: e.target.value,
            isValueUpdated:true,
          });
        } else
          setFilterValues({
            ...filterValues,
            [e.target.name]: e.target.value,
            isValueUpdated:true,
          });
          
         
      };
      useEffect(()=>{
        if(filterValues.isValueUpdated){
         const filter=getClientConfigFilters(filterValues)
          
        props.setValues({
          ...props.values,
          tabFilters:{
            ...props.values["tabFilters"],
            value:filter[0].value,
            isValueUpdated:true
          }
        })
      }
      },[filterValues])
    

    return(
        <>
  
                    <>
                     

                        <div style={{ display: "flex" ,gap:"8px",alignItems:"start"}} >
                          <div style={{display:"flex",flexDirection:"column"}} >
                           <Typography  marginBottom={2} color={"#606060"}>
                         Product filter view for the catalogue
                      </Typography>
                      <div style={{ display: "flex" ,gap:"8px",alignItems:"center"}} >
                          <div style={{ border:"0.3px solid grey" , width:"220px", padding:"0px 0px 0px 8px",borderRadius:"8px" }}  >
                          <CustomRadio
                            label="Tab view"
                            value="tabview"
                            name="tabFilterType"
                            checked={props.values?.tabFilterType?.value === "tabview"}
                            onChange={handleSelectValueChange}
                            color="#909090"
                          />
                          </div>
                          <div style={{border:"0.3px solid grey" ,width:"220px", padding:"0px 0px 0px 8px",borderRadius:"8px" }} >
                          <CustomRadio
                            label="Dropdown"
                            value="dropdown"
                            name="tabFilterType"
                            checked={props.values?.tabFilterType?.value === "dropdown"}
                            onChange={handleSelectValueChange}
                            color="#909090"
                          />
                          </div >
                          </div>
                          </div>
                          

                     
                   
                      {filterTypePreview && (
                        <div style={{ maxWidth: hasActiveChild ? "50px" : "600px" }}>
                          {props.values?.tabFilterType?.value === "dropdown" && (
                            <>
                              <div>
                                <img
                                  style={{ maxWidth: "200px",height:"100px" }}
                                  src={dropDownPreviewImage}
                                  alt="dropDownPreview"
                                ></img>
                              </div>
                            </>
                          )}
                          {props.values?.tabFilterType?.value === "tabview" && (
                            <>
                              <div >
                                <img
                                  style={{ maxWidth: "200px", maxHeight:"120px" }}
                                  src={tabviewPreviewImage}
                                  alt="tabViewPreview"
                                ></img>
                              </div>
                            </>
                          )}
                        </div>
                      )}
                         </div>
        
                      <Typography marginY={0} color={"#606060"}>
                        Product filters
                      </Typography>
                      <div style={{display:"flex",gap:"8px"}} >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                       
                        <FeatureDropDown
                          onChange={handleFilterValueChange}
                          placeholder="Level 1"
                          value={filterValues?.filter1}
                          name="filter1"
                          options={filteredOptionsLevel1}
                          selectLableId="skuCodeCondition"
                          size="small"
                          sx={{
                            minWidth: "32%",
                            marginTop: "0.5rem",
                            marginBottom: "1rem",
                            borderRadius: "8px",
                          }}
                        />
                      </div>
                      {!secondFilter && filterValues.filter2 === "none" ? (
                        <></>
                      ) : (
                        <>
                          <div
                            style={{
                              display: "flex",
                              gap: "8px",
                              alignItems: "center",
                            }}
                          >
                            
                            <FeatureDropDown
                              onChange={handleFilterValueChange}
                              placeholder="Level 2"
                              value={
                                filterValues.filter2 !== "none"
                                  ? filterValues.filter2
                                  : filteredOptionsLevel2[0]
                              }
                              name="filter2"
                              options={filteredOptionsLevel2}
                              selectLableId="skuCodeCondition"
                              size="small"
                              sx={{
                                minWidth: "32%",
                                marginTop: "0.5rem",
                                marginBottom: "1rem",
                                borderRadius: "8px",
                              }}
                            />
                            {filterValues.filter2 !== "" && (
                              <IconButton
                                aria-label="delete"
                                size="small"
                                onClick={() => handleFilterDelete("filter2")}
                                sx={{
                                  backgroundColor: "#ffedee",
                                  color: "red",
                                  "&:hover": {
                                    backgroundColor: "#ffedee",
                                    color: "red",
                                  },
                                }}
                              >
                                <RemoveOutlinedIcon style={{ fontSize: "18px" }} />
                              </IconButton>
                            )}
                          </div>
                        </>
                      )}
                      {(thirdFilter === false && filterValues.filter3 === "none") ||
                      props.values?.tabFilterType?.value === "dropdown" ? (
                        <></>
                      ) : (
                        <>
                          <div
                            style={{
                              display: "flex",
                              gap: "8px",
                              alignItems: "center",
                            }}
                          >
                            
                            <FeatureDropDown
                              onChange={handleFilterValueChange}
                              placeholder="Level 3"
                              value={filterValues.filter3}
                              name="filter3"
                              options={filteredOptionsLevel3}
                              selectLableId="skuCodeCondition"
                              size="small"
                              sx={{
                                minWidth: "32%",
                                mt: 0.5,
                                mb: 1,
                                borderRadius: "8px",
                              }}
                            />
                            {filterValues.filter3 !== "" && (
                              <IconButton
                                aria-label="delete"
                                size="small"
                                onClick={() => handleFilterDelete("filter3")}
                                sx={{
                                  backgroundColor: "#ffedee",
                                  color: "red",
                                  "&:hover": {
                                    backgroundColor: "#ffedee",
                                    color: "red",
                                  },
                                }}
                              >
                                <RemoveOutlinedIcon style={{ fontSize: "18px" }} />
                              </IconButton>
                            )}
                          </div>
                        </>
                      )}
        
                      {props.values?.tabFilterType?.value !== "dropdown" &&
                        filterValues.filter3 === "none" && (
                          <div
                            style={{
                              display: "flex",
                              gap: "8px",
                              width: "100%",
                              marginTop: "10px",
                              alignItems: "center",
                            }}
                          >
                            <div style={{ width: "15%" }}>
                              <Typography>Add Filter</Typography>
                            </div>
                            <AddFilterButton onClick={handleFilterAdd} />
                          </div>
                        )}
                      {props.values?.tabFilterType?.value === "dropdown" &&
                        filterValues.filter2 === "none" && (
                          <>
                            <div
                              style={{
                                display: "flex",
                                gap: "8px",
                                width: "100%",
                                marginTop: "10px",
                                alignItems: "center",
                              }}
                            >
                              <div style={{ width: "15%" }}>
                                <Typography>Add Filters:</Typography>
                              </div>
                              <AddFilterButton onClick={handleFilterAdd} />
                            </div>
                          </>
                        )}
                        </div>
                    </>
             
                  
                            
                             {/* <ConfigWrapper heading="Dummy Image Upload">
                                        <>
                                          <Typography color={"#606060"} marginTop={2}>
                                            Upload the image you wish to display when no image is available
                                            for the SKU
                                          </Typography>
                                          <div className="generic_form_container">
                                            <FeatureDropDown
                                              onChange={handleDummyImageChange}
                                              value={skuImageCatagory ?? "Beverages"}
                                              label={
                                                skuImageCatagory?.length === 0 ? "Select Category" : ""
                                              }
                                              name="defaultCatalogueImage"
                                              selectLableId=""
                                              placeholder="Select Dummy Image"
                                              options={dummyImageOptions.map(
                                                (imageOption) => imageOption.title
                                              )}
                                              size="small"
                                              sx={{
                                                minWidth: "32%",
                                                marginTop: "0.5rem",
                                                marginBottom: "1rem",
                                                borderRadius: "0%",
                                              }}
                                            />
                            
                                            <CameraImage
                                              image={image}
                                              setImage={setImage}
                                              currImage={currImage}
                                              disable={skuImageCatagory ? true : false}
                                              removeButton={true}
                                              removeFunction={handleRemoveFunction}
                                            />
                                          </div>
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                            }}
                                          >
                                            <Typography
                                              variant="caption"
                                              sx={{
                                                cursor: "pointer",
                                                color: "#00C6B1",
                                              }}
                                            >
                                              *The image resolution should be 500x500
                                            </Typography>
                                          </div>
                                        </>
                                      </ConfigWrapper> */}
                                        {/* <ConfigWrapper heading="Labels"> */}
                                                  {/* <>
                                                    <Typography color={"#606060"}>
                                                      Mention required labels:
                                                    </Typography>
                                                    <FlexInputLabel
                                                      label="UOM 1 :"
                                                      name={"caseLabel"}
                                                      value={labelCheckValueMapping["caseLabel"].value}
                                                      onChange={handleLabelUOMValueChange}
                                                      placeholder=""
                                                      max={5}
                                                      min={3}
                                                      onValidationFailiure={setValidationFailiure}
                                                    />
                                                    <FlexInputLabel
                                                      label="UOM 2 :"
                                                      name={"packLabel"}
                                                      value={labelCheckValueMapping["packLabel"].value}
                                                      onChange={handleLabelUOMValueChange}
                                                      placeholder=""
                                                      max={5}
                                                      min={3}
                                                      onValidationFailiure={setValidationFailiure}
                                                    />
                                                    <FlexInputLabel
                                                      label="UOM 3 :"
                                                      name={"otherLabel"}
                                                      value={labelCheckValueMapping["otherLabel"].value}
                                                      onChange={handleLabelUOMValueChange}
                                                      placeholder=""
                                                      max={5}
                                                      min={3}
                                                      onValidationFailiure={setValidationFailiure}
                                                    />
                                                    <FlexInputLabel
                                                      label="MRP :"
                                                      name={"mrpLabel"}
                                                      value={props.values?.mrpLabel?.value}
                                                      onChange={handleLabelValueChange}
                                                      placeholder=""
                                                      max={11}
                                                      min={3}
                                                      onValidationFailiure={setValidationFailiure}
                                                    />
                                                    {/* multi variant */}
                                                    {/* <FlexInputLabel
                                                      label="Similar Product :"
                                                      name={"multiVariantHeader"}
                                                      value={props.values?.multiVariantHeader?.value}
                                                      onChange={handleLabelValueChange}
                                                      placeholder=""
                                                      max={25}
                                                      min={3}
                                                      onValidationFailiure={setValidationFailiure} 
                                                    />
                                                  </> */} 
                                                {/* </ConfigWrapper>  */}
        </>
    )
}

export const CatalogueConfigCustomSkuTile=(props:Props)=>{
  const [skuCodeValueOne, setSkuCodeValueOne] = useState<string>("");
  const [skuCodeValueTwo, setSkuCodeValueTwo] = useState<string>("");
    const [validationFailiure, setValidationFailiure] = useState<boolean>(false);
   const [error, setErrorDisplay] = useState<boolean>(false);
    const [maxAllowedDigits, setMaxAllowedDigits] = useState<number>(
      props.values?.maxAllowedDigitForOrder?.value
    );
   const [removeConfigList,setRemoveConfigList] = useState<string[]>(
    []
  );
   const getSkuCodeValueLabelFromSaved = (val:string)=>{
    if(val==="front"){
      return "first"
    }
    else
    {
      return val;
    }
  }
  const setSkuCodeConfiguration = () => {
    if (props.values?.skuCodeCondition?.value !== "") {
      setSkuCodeValueOne(props.values?.skuCodeCondition?.value?.split(" ")[0]);
      setSkuCodeValueTwo(getSkuCodeValueLabelFromSaved(props.values?.skuCodeCondition?.value?.split(" ")[1]));
    }
  };

  
    useEffect(() => {
      setSkuCodeConfiguration();
    }, [props.values?.skuCodeCondition]);

    
     const handleMaximumAllowedDigitDecrement = () => {
    const updatevalue = maxAllowedDigits - 1;
    props.setValues({
      ...props.values,
      maxAllowedDigitForOrder: {
        ...props.values?.maxAllowedDigitForOrder,
        value: updatevalue,
        isValueUpdated: true,
        domainType: "catalogue_configuration",
      },
    });
    setMaxAllowedDigits((prev) => prev - 1);
   
  }
  const handleRadioChange = (e: SelectChangeEvent<unknown>,checked:boolean) => {
    
      const { name } = e.target;
      const newValue = checked === true;
  
      props.setValues((prevValues:any) => (
        {
        ...prevValues,
        [name]: {
          ...prevValues[name],
          value: newValue,
          isValueUpdated: true,
          domainType: "catalogue_configuration",
        },
      }));
      
    };
     const getSkuCodeValueTwoToSave = (val: string) => {
    if (val === "first") {
      return "front";
    } else {
      return val;
    }
  };
   const handleValueChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (e.target.max && e.target.value.length > parseInt(e.target.max)) return;
      if (e.target.min && e.target.value.length < parseInt(e.target.min)) {
        setValidationFailiure(true);
        setErrorDisplay(true);
      } else {
        setValidationFailiure(false);
        setErrorDisplay(false);
      }
      const { name, value } = e.target;
      const keyName = name;
      const newValue = value.toString();
  
      // Update the state
      props.setValues((prevValues:any) => ({
        ...prevValues,
        [keyName]: {
          ...prevValues[keyName],
          value: newValue,
          isValueUpdated: true,
          domainType: "catalogue_configuration",
        },
      }));
   
    };
    const handleFilterConditionCheck = (e: SelectChangeEvent<unknown>) => {
      const keyName = e.target.name;
      setSkuCodeValueTwo(e.target.value as string);
     
      if (skuCodeValueOne !== "" && e.target.value !== "") {
        const value = skuCodeValueOne + " " + getSkuCodeValueTwoToSave(e.target.value as string);
        props.setValues({
          ...props.values,
          [keyName]: {
            ...props.values[keyName],
            value: value,
            isValueUpdated: true,
            domainType: "catalogue_configuration",
          },
        });
        setSkuCodeValueOne(skuCodeValueOne);
        // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
        //   {
        //     ...values,
        //     [keyName]: {
        //       ...values[keyName],
        //       value: value,
        //       isValueUpdated: true,
        //       domainType: "catalogue_configuration",
        //     },
        //   },
        //   catalogueConfig,
        //   defaultCatalogueInputValues
        // );
        // setPlayGroundConfiguration(convertedVals);
      }
    };
      const handleValueChange = (
      e: React.ChangeEvent<HTMLInputElement>,
      newValue: number
    ) => {
      const keyName = e.target.name;
  
      if (keyName === "maxAllowedDigitForOrder") {
        if (newValue > 4) {
          openPopup("Error", "You can select up to 4 digits for order");
          return;
        }
  
        props.setValues((prevValues:any) => ({
          ...prevValues,
          [keyName]: {
            ...prevValues[keyName],
            value: newValue,
            isValueUpdated: true,
            domainType: "catalogue_configuration",
          },
        }));
        // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
        //   {
        //     ...values,
        //     [keyName]: {
        //       ...values[keyName],
        //       value: newValue,
        //       isValueUpdated: true,
        //       domainType: "catalogue_configuration",
        //     },
        //   },
        //   catalogueConfig,
        //   defaultCatalogueInputValues
        // );
        // setPlayGroundConfiguration(convertedVals);
      } else if (keyName === "skuCodeConditionOne") {
        if (newValue < 0) {
          openPopup("Error", "You can't set a value less than 0");
          return;
        }
        if (newValue >= 7) {
          openPopup("Error", "You can't set a value more than 6");
        }
  
        setSkuCodeValueOne(newValue.toString());
        props.setValues((prevValues:any) => ({
          ...prevValues,
          skuCodeCondition: {
            ...prevValues["skuCodeCondition"],
            value: `${newValue} ${getSkuCodeValueTwoToSave(skuCodeValueTwo)}`,
            isValueUpdated: true,
            domainType: "catalogue_configuration",
          },
        }));
        // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
        //   {
        //     ...values,
        //     ["skuCodeCondition"]: {
        //       ...values["skuCodeCondition"],
        //       value: `${newValue} ${skuCodeValueTwo}`,
        //       isValueUpdated: true,
        //       domainType: "catalogue_configuration",
        //     },
        //   },
        //   catalogueConfig,
        //   defaultCatalogueInputValues
        // );
        // setPlayGroundConfiguration(convertedVals);
      } else {
        props.setValues((prevValues:any) => ({
          ...prevValues,
          [keyName]: {
            ...prevValues[keyName],
            value: newValue,
            isValueUpdated: true,
            domainType: "catalogue_configuration",
          },
        }));
        // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
        //   {
        //     ...values,
        //     [keyName]: {
        //       ...values[keyName],
        //       value: newValue,
        //       isValueUpdated: true,
        //       domainType: "catalogue_configuration",
        //     },
        //   },
        //   catalogueConfig,
        //   defaultCatalogueInputValues
        // );
        // setPlayGroundConfiguration(convertedVals);
      }
    };
         const handleMaximumAllowedDigitIncrement = () => {
    const updatevalue = maxAllowedDigits + 1;
    props.setValues({
      ...props.values,
      maxAllowedDigitForOrder: {
        ...props.values?.maxAllowedDigitForOrder,
        value: updatevalue,
        isValueUpdated: true,
        domainType: "catalogue_configuration",
      },
    });
    setMaxAllowedDigits((prev) => prev + 1);
    // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
    //   {
    //     ...values,
    //     ["maxAllowedDigitForOrder"]: {
    //       ...values["maxAllowedDigitForOrder"],
    //       value: updatevalue,
    //       isValueUpdated: true,
    //       domainType: "catalogue_configuration",
    //     },
    //   },
    //   catalogueConfig,
    //   defaultCatalogueInputValues
    // );
    // setPlayGroundConfiguration(convertedVals);
  };
   const [labelCheckValueMapping, setLabelCheckValueMapping] = useState({
      caseLabel: {
        isChecked: props.values?.caseUnitLabel?.loadedFromApi === true,
        value: props.values?.caseUnitLabel?.loadedFromApi === true ? props.values?.caseUnitLabel?.value : props.values?.focCaseUnitLabel?.value,
      },
      packLabel: {
        isChecked: props.values?.packUnitLabel?.loadedFromApi === true,
        value: props.values?.packUnitLabel?.loadedFromApi === true ? props.values?.packUnitLabel?.value : props.values?.focPackUnitLabel?.value,
      },
      otherLabel: {
        isChecked: props.values?.otherUnitLabel?.loadedFromApi === true,
        value: props.values?.otherUnitLabel?.loadedFromApi === true ? props.values?.otherUnitLabel?.value : props.values?.focOtherUnitLabel?.value,
      },
    });
   
    
      useEffect(() => {
    
        setLabelCheckValueMapping({
          caseLabel: {
            isChecked: props.values?.caseUnitLabel?.loadedFromApi === true,
            value: props.values?.caseUnitLabel?.loadedFromApi === true ? props.values?.caseUnitLabel?.value : props.values?.focCaseUnitLabel?.value,
          },
          packLabel: {
            isChecked: props.values?.packUnitLabel?.loadedFromApi === true,
            value: props.values?.packUnitLabel?.loadedFromApi === true ? props.values?.packUnitLabel?.value : props.values?.focPackUnitLabel?.value,
          },
          otherLabel: {
            isChecked: props.values?.otherUnitLabel?.loadedFromApi === true,
            value: props.values?.otherUnitLabel?.loadedFromApi === true ? props.values?.otherUnitLabel?.value : props.values?.focOtherUnitLabel?.value,
          },
        });
      }, [
        props.values?.packUnitLabel,
        props.values?.focPackUnitLabel,
        props.values?.caseUnitLabel,
        props.values?.focCaseUnitLabel,
        props.values?.otherUnitLabel,
        props.values?.focOtherUnitLabel,
      ]);
    const handleLabelCheckChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const labelToConfigMapping: Record<
          string,
          { checked: string; unChecked: string } | undefined
        > = {
          caseLabel: {
            checked: "caseUnitLabel",
            unChecked: "focCaseUnitLabel",
          },
          packLabel: {
            checked: "packUnitLabel",
            unChecked: "focPackUnitLabel",
          },
          otherLabel: {
            checked: "otherUnitLabel",
            unChecked: "focOtherUnitLabel",
          },
        };
    
        const labelName = e.target.name as "caseLabel" | "packLabel" | "otherLabel";
        const isChecked = e.target.checked;
    
        const configMapping = labelToConfigMapping[labelName];
    
        if (configMapping) {
          props.setValues((prev:any) => {
            const checkedConfig = configMapping.checked;
            const unCheckedConfig = configMapping.unChecked;
    
            if (isChecked) {
              setRemoveConfigList((prevList) => {
                const updatedList = prevList.filter((config) => config !== checkedConfig);
                if (!updatedList.includes(unCheckedConfig)) {
                  updatedList.push(unCheckedConfig);
                }
                return updatedList;
              });
              prev[checkedConfig] = {
                ...prev[checkedConfig],
                value: labelCheckValueMapping[labelName].value,
                isValueUpdated: true,
                domainType: "catalogue_configuration",
                loadedFromApi: true
              };
              if (unCheckedConfig) {
                prev[unCheckedConfig] = {
                  ...prev[unCheckedConfig],
                  value: "null",
                  isValueUpdated: true,
                  domainType: "catalogue_configuration",
                  loadedFromApi: false
                };
              }
            } else {
              setRemoveConfigList((prevList) => {
                const updatedList = prevList.filter((config) => config !== unCheckedConfig);
                if (!updatedList.includes(checkedConfig)) {
                  updatedList.push(checkedConfig);
                }
                return updatedList;
              });
              if (unCheckedConfig) {
                prev[unCheckedConfig] = {
                  ...prev[unCheckedConfig],
                  value: labelCheckValueMapping[labelName].value,
                  isValueUpdated: true,
                  domainType: "catalogue_configuration",
                  loadedFromApi: true
                };
              }
              prev[checkedConfig] = {
                ...prev[checkedConfig],
                value: "null",
                isValueUpdated: true,
                domainType: "catalogue_configuration",
                loadedFromApi: false
              };
            }
    
            return { ...prev };
          });
    
          // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
          //   values,
          //   catalogueConfig,
          //   defaultCatalogueInputValues
          // );
          // setPlayGroundConfiguration(convertedVals);
        }
      };
   
  return(
     <>
  <div style={{ display: "flex", gap: "1vw" }}>
                <Typography sx={{fontWeight:"500"}} >Show SKU code</Typography>
              
                  <DashboardToggleSwitch
                    label="Yes"
                    checked={props.values?.skuCodeVisibility?.value === true}
                   
                    name="skuCodeVisibility"
                    onChange={(e,checked)=>handleRadioChange(e,checked)}
                  />
                  
                </div>
                {props.values?.skuCodeVisibility?.value && (
                  <>
                    <Typography color={"#606060"} marginTop={2}>
                      Select Digits of the SKU code to be visible
                    </Typography>
                    <Stack direction={"row"} gap={5}>
                      <div style={{ display: "flex", gap: "2vw" }}>
                                            <CustomRadio
                                              label="First"
                                              value="first"
                                              name="skuCodeCondition"
                                              checked={props.values?.skuCodeCondition?.value === "first"}
                                              onChange={handleFilterConditionCheck}
                                              color="#909090"
                                            />
                                            <CustomRadio
                                              label="Last"
                                              value="last"
                                              name="skuCodeCondition"
                                              checked={props.values?.skuCodeCondition?.value !== "first"}
                                              onChange={handleFilterConditionCheck}
                                              color="#909090"
                                            />
                                          </div>
                      <NumberInput
                        value={Number(skuCodeValueOne)}
                        onChange={(e, newValue) => handleValueChange(e, newValue)}
                        name="skuCodeConditionOne"
                        min={1}
                        max={6}
                        step={1}
                      />
                    </Stack>
                    <Typography
                      variant="caption"
                      sx={{
                        cursor: "pointer",
                        color: "#00C6B1",
                      }}
                    >
                      upto 6 digits are allowed
                    </Typography>
                  </>
                )}
                 <div style={{ display: "flex", gap: "1vw",marginTop:"8px" }}>
                <Typography  sx={{fontWeight:"500"}} >
                 Show Pack size 
                </Typography>
               
                  <DashboardToggleSwitch
                    label="Yes"
                    checked={props.values?.pieceSizeVisibility?.value === true}
                 
                    name="pieceSizeVisibility"
                     onChange={(e,checked)=>handleRadioChange(e,checked)}
                  />
                  
                </div>
                {props.values?.pieceSizeVisibility?.value && (
                  <>
                    <Typography color={"#606060"} marginTop={2}>
                      What should be the label for Pack size?
                    </Typography>
                    <Input
                      style={{ width: "50%", display: "flex" }}
                      value={props.values?.pieceSizeLabel?.value}
                      onChange={handleValueChangeInput}
                      name="pieceSizeLabel"
                      inputProps={{ max: 11, min: 3 }}
                    />
                    {error && (
                      <Typography
                        ml={"6px"}
                        style={{ color: "red", fontSize: "12px" }}
                      >{`Label must be of at least 3 characters.`}</Typography>
                    )}
                  </>
                )}
                <Typography marginTop={2} sx={{fontWeight:"500"}} >
                  Select the UOMs available for taking order
                </Typography>
                <div style={{display:"flex"}} >
                  <FeaturesCheckbox
                    onChange={handleLabelCheckChange}
                    checked={labelCheckValueMapping["caseLabel"].isChecked}
                    name="caseLabel"
                    label="Case"
                   
                  />
                  <FeaturesCheckbox
                    onChange={handleLabelCheckChange}
                    checked={labelCheckValueMapping["packLabel"].isChecked}
                    name="packLabel"
                    label="Piece"
                  />
                  <FeaturesCheckbox
                    onChange={handleLabelCheckChange}
                    checked={labelCheckValueMapping["otherLabel"].isChecked}
                    name="otherLabel"
                    label="Other"
                  />
                </div>
                <Typography marginTop={2} >
                  Maximum allowed digit for ordering
                </Typography>
                <div>
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      marginTop: "10px",
                      marginBottom: "10px",
                      alignItems: "center",
                    }}
                  >
                    <Button
                      variant="outlined"
                      onClick={handleMaximumAllowedDigitDecrement}
                      disabled={maxAllowedDigits <= 2}
                      style={{
                        width: "35px",
                        height: "25px",
                        minWidth: "unset",
                        color: maxAllowedDigits <= 2 ? undefined : "#00C6B2",
                        backgroundColor:
                          maxAllowedDigits <= 2 ? undefined : "#EFFDFC",
                        padding: "0",
                        fontSize: "16px",
                        lineHeight: "1",
                        borderColor: maxAllowedDigits <= 2 ? undefined : "#00C6B2",
                      }}
                    >
                      -
                    </Button>
    
                    {Array.from({ length: maxAllowedDigits }).map((_, index) => (
                      <div
                        key={index}
                        style={{
                          width: "40px",
                          height: "40px",
                          border: "1px solid #1C7EA0",
                          fontWeight: "bold",
                          borderRadius: "5px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Typography>9</Typography>
                      </div>
                    ))}
    
                    <Button
                      variant="outlined"
                      onClick={handleMaximumAllowedDigitIncrement}
                      disabled={maxAllowedDigits >= 4}
                      style={{
                        width: "35px",
                        height: "25px",
                        minWidth: "unset",
                        color: maxAllowedDigits >= 4 ? undefined : "#00C6B2",
                        backgroundColor:
                          maxAllowedDigits >= 4 ? undefined : "#EFFDFC",
                        padding: "0",
                        fontSize: "16px",
                        lineHeight: "1",
                        borderColor: maxAllowedDigits >= 4 ? undefined : "#00C6B2",
                      }}
                    >
                      +
                    </Button>
                  </div>
                </div>
                <Typography
                  marginTop={4}
                  variant="caption"
                  sx={{
                    cursor: "pointer",
                    color: "#00C6B1",
                  }}
                >
                  minimum 2 and maximum 4 digits are allowed
                </Typography>
                </>
         
  )
  
}
export const CatalogueConfigCustomSimilarProductGrouping=(props:Props)=>{
  const [visibelPreviewImg, setVisiblePreviewImg] = useState<boolean>(false);
   const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
     const [infoClick, setInfoClick] = useState<boolean>(false);
     const [maxAllowedDigits, setMaxAllowedDigits] = useState<number>(
      props.values?.maxAllowedDigitForOrder?.value
    );
   const handlePreviewVisibility = () => {
    setVisiblePreviewImg(!visibelPreviewImg);
  };
    const handleSelectValueChange = (e: SelectChangeEvent<unknown>) => {
      const { name, value } = e.target;
  
      let parsedValue: boolean | string;
  
      if (value === "true") {
        parsedValue = true;
      } else if (value === "false") {
        parsedValue = false;
      } else {
        parsedValue = value as string;
      }
  
      props.setValues((prevValues:any) => ({
        ...prevValues,
        [name]: {
          ...prevValues[name],
          value: parsedValue,
          isValueUpdated: true,
          domainType: "catalogue_configuration",
        },
      }));

      // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
      //   {
      //     ...values,
      //     [name]: {
      //       ...values[name],
      //       value: parsedValue,
      //       isValueUpdated: true,
      //       domainType: "catalogue_configuration",
      //     },
      //   },
      //   catalogueConfig,
      //   defaultCatalogueInputValues
      // );
      // setPlayGroundConfiguration(convertedVals);
    };
     const handleToggleChange = (e: SelectChangeEvent<unknown>,checked:boolean) => {
      const { name} = e.target;
      
  
      
  
      props.setValues((prevValues:any) => ({
        ...prevValues,
        [name]: {
          ...prevValues[name],
          value: checked,
          isValueUpdated: true,
          domainType: "catalogue_configuration",
        },
      }));

      // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
      //   {
      //     ...values,
      //     [name]: {
      //       ...values[name],
      //       value: parsedValue,
      //       isValueUpdated: true,
      //       domainType: "catalogue_configuration",
      //     },
      //   },
      //   catalogueConfig,
      //   defaultCatalogueInputValues
      // );
      // setPlayGroundConfiguration(convertedVals);
    };
     const handlePopoverClose = () => {
    setAnchorEl(null);
  };
     const open = Boolean(anchorEl);
      const handleMaximumAllowedDigitDecrement = () => {
    const updatevalue = maxAllowedDigits - 1;
    props.setValues({
      ...props.values,
      maxAllowedDigitForOrder: {
        ...props.values?.maxAllowedDigitForOrder,
        value: updatevalue,
        isValueUpdated: true,
        domainType: "catalogue_configuration",
      },
    });
    setMaxAllowedDigits((prev) => prev - 1);
    // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
    //   {
    //     ...values,
    //     ["maxAllowedDigitForOrder"]: {
    //       ...values["maxAllowedDigitForOrder"],
    //       value: updatevalue,
    //       isValueUpdated: true,
    //       domainType: "catalogue_configuration",
    //     },
    //   },
    //   catalogueConfig,
    //   defaultCatalogueInputValues
    // );
    // setPlayGroundConfiguration(convertedVals);
  }
    const handleInfoIconClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setInfoClick(!infoClick);
  };
  return(
   
                                     
                                        <>
                                        
                                          <div style={{ display: "flex", justifyContent: "space-between",alignItems:"center" }}>
                                            <Typography color={"#606060"}>
                                              Add a similar product dropdown in the SKU tile?
                                            </Typography>
                                                     <div style={{ display: "flex", gap: "2vw" }}>
                  <DashboardToggleSwitch
                    checked={props.values?.multiVariantOrder?.value === true}
                    onChange={(e,checked)=>handleToggleChange(e,checked)}
                    name="multiVariantOrder"
                    label="multiVariantOrder"
                  />
                  </div>
                                            <div
                                              style={{
                                                alignSelf: "center",
                                                color: "#227C9D",
                                                textDecoration: "underline",
                                              }}
                                              onClick={handlePreviewVisibility}
                                            >
                                              <IconButton sx={{ color: "#227C9D" }}>
                                                <ImageIcon fontSize="small" />
                                              </IconButton>
                                              Preview selection
                                            </div>
                                          </div>
                                          {/* <div style={{ display: "flex", gap: "2vw" }}>
                                            <CustomRadio
                                              label="Yes"
                                              value={true}
                                              name="multiVariantOrder"
                                              checked={props.values?.multiVariantOrder?.value === true}
                                              onChange={handleSelectValueChange}
                                              color="#909090"
                                            />
                                            <CustomRadio
                                              label="No"
                                              value={false}
                                              name="multiVariantOrder"
                                              checked={props.values?.multiVariantOrder?.value !== true}
                                              onChange={handleSelectValueChange}
                                              color="#909090"
                                            />
                                          </div> */}
                                    
                                          {visibelPreviewImg && (
                                            <div>
                                              {props.values?.multiVariantOrder?.value === true ? (
                                                <>
                                                  <div>
                                                    <img
                                                      style={{ width: "400px" }}
                                                      src={similarProductGroup}
                                                      alt="similarProductGroup selected Preview"
                                                    ></img>
                                                  </div>
                                                </>
                                              ) : (
                                                <>
                                                  <div>
                                                    <img
                                                      style={{ width: "400px" }}
                                                      src={similarProductGroupNo}
                                                      alt="similarProductGroup not selected Preview"
                                                    ></img>
                                                  </div>
                                                </>
                                              )}
                                            </div>
                                          )}
                                          {props.values?.multiVariantOrder?.value && (
                                            <>
                                              <Typography marginTop={2} color={"#606060"}>
                                                Select the type on which the product should be grouped?
                                              </Typography>
                                              <div
                                                style={{
                                                  display: "flex",
                                                  gap: "3vw",
                                                  alignItems: "baseline",
                                                }}
                                              >
                                                <CustomRadio
                                                  label="Pack Size"
                                                  value={"pieceSize"}
                                                  name="multiVariantGroupingOption"
                                                  checked={
                                                    props.values?.multiVariantGroupingOption?.value === "pieceSize"
                                                  }
                                                  onChange={handleSelectValueChange}
                                                  color="#909090"
                                                />
                            
                                                <div style={{ display: "flex" }}>
                                                  <CustomRadio
                                                    label="Group ID"
                                                    value={"groupId"}
                                                    name="multiVariantGroupingOption"
                                                    checked={
                                                      props.values?.multiVariantGroupingOption?.value === "groupId"
                                                    }
                                                    onChange={handleSelectValueChange}
                                                    color="#909090"
                                                  />
                                                  <IconButton
                                                    size="small"
                                                    onClick={handleInfoIconClick}
                                                    style={{
                                                      position: "relative",
                                                      right: "15px",
                                                      bottom: "8px",
                                                      verticalAlign: "super", // Aligns it as superscript
                                                      fontSize: "0.75rem", // Reduces the size if you want
                                                      color: "rgb(34, 124, 157)",
                                                    }}
                                                  >
                                                    <InfoOutlinedIcon fontSize="small" />
                                                  </IconButton>
                                                  <Popover
                                                    id="mouse-over-popover"
                                                    open={open}
                                                    anchorEl={anchorEl}
                                                    onClose={handlePopoverClose}
                                                    anchorOrigin={{
                                                      vertical: "bottom",
                                                      horizontal: "left",
                                                    }}
                                                    transformOrigin={{
                                                      vertical: "top",
                                                      horizontal: "left",
                                                    }}
                                                    PaperProps={{
                                                      style: { padding: "10px", maxWidth: "300px" },
                                                    }}
                                                  >
                                                    <Typography variant="body2" color="textPrimary">
                                                      {/* <strong>Label:</strong> Is a unique identifier for
                                                        the customer's system.
                                                        <br />
                                                        <strong>Key/Code:</strong> Code which is used for
                                                        tracking the order in the DMS. */}
                                                      This particular configuration is data dependent i.e
                                                      will get reflected in the app if the relevant data is
                                                      uploaded in required format.
                                                    </Typography>
                                                  </Popover>
                                                  {/* <ClickAwayListener
                                                      onClickAway={() => setInfoClick(false)}
                                                    >
                                                      <div
                                                        style={{
                                                          alignSelf: "flex-start",
                                                          color: "#909090",
                                                          position: "relative",
                                                          left: "-20px",
                                                          top: "-4px",
                                                        }}
                                                      >
                                                        <CustomWidthTooltip
                                                          open={infoClick}
                                                          disableHoverListener
                                                          disableFocusListener
                                                          disableTouchListener
                                                          TransitionComponent={Fade}
                                                          TransitionProps={{ timeout: 600 }}
                                                          arrow
                                                          placement="top-start"
                                                          title="This particular configuration is data dependent i.e will get reflected in the app if the relevant data is uploaded in required format."
                                                        >
                                                          <IconButton onClick={handleInfoIconClick}>
                                                            {" "}
                                                            <InfoOutlinedIcon fontSize="small" />{" "}
                                                          </IconButton>
                                                        </CustomWidthTooltip>
                                                      </div>
                                                    </ClickAwayListener> */}
                                                </div>
                                              </div>
                                            </>
                                          )}
                                        </>
                                  
  )
}

export const CatalogueConfigCustomDummyImageUpload=(props:Props)=>{
  
  const [dummyImageOptions] = useState([
      {
        value:
          "https://d2nvw4ekms3xzy.cloudfront.net/salind/images/admin_1726127589190_1726127589189-JUmJMJHwFljP.png",
        title: "Beverages",
      },
      {
        value:
          "https://d2nvw4ekms3xzy.cloudfront.net/salind/images/admin_1726127465117_1726127465116-APWNasRoQAJm.png",
        title: "Snacks",
      },
      {
        value:
          "https://d2nvw4ekms3xzy.cloudfront.net/salind/images/admin_1726127513316_1726127513316-iJPpCSrHcSRq.png",
        title: "Confectionary",
      },
      {
        value:
          "https://d2nvw4ekms3xzy.cloudfront.net/salind/images/admin_1726127589190_1726127589189-JUmJMJHwFljP.png",
        title: "Stationary",
      },
      {
        value:
          "https://d2nvw4ekms3xzy.cloudfront.net/salind/images/admin_1726127557972_1726127557971-CDhyrybWbrON.png",
        title: "Health & Wellness",
      },
      {
        value:
          "https://d2nvw4ekms3xzy.cloudfront.net/salind/images/admin_1726127589190_1726127589189-JUmJMJHwFljP.png",
        title: "Personal Care & Hygiene",
      },
    ]);
    const [currImage,setCurrImage] = useState<string | undefined>(
        "https://d2nvw4ekms3xzy.cloudfront.net/salind/images/admin_1726127589190_1726127589189-JUmJMJHwFljP.png"
      );
     const [image, setImage] = useState();
      const [skuImageCatagory, setSkuImageCatagory] = useState<string>();
      function handleRemoveFunction() {
    setImage(undefined);
    setCurrImage(undefined);
    setSkuImageCatagory("");
  }
   function handlePlaygroundConfig(url: string) {
    props.setValues({
      ...props.values,
      defaultCatalogueImage: {
        ...props.values?.defaultCatalogueImage,
        value: url,
        isValueUpdated: true,
        domainType: "catalogue_configuration",
      },
    });
    }
    // useEffect(()=>{
    //   handleDefaultCatalogueImage()
    // },[props.values?.defaultCatalogueImage])
    const handleDefaultCatalogueImage = () => {
    setImage(undefined);
    
    setCurrImage(
      props.values?.defaultCatalogueImage?.value ??
        currImage
    );

    const defaultCatalogueImage =
       props.values?.defaultCatalogueImage?.value ??
      null;

    if (defaultCatalogueImage) {
      setSkuImageCatagory("");
    }
  };
   
    const handleDummyImageChange = (e: SelectChangeEvent<unknown>) => {
      setSkuImageCatagory(e.target.value as string);
  
      setCurrImage(
        dummyImageOptions.filter(
          (dummyImage) => dummyImage.title === e.target.value
        )[0].value
      );
      handlePlaygroundConfig(
        dummyImageOptions.filter(
          (dummyImage) => dummyImage.title === e.target.value
        )[0].value
      );
    };
  return(
    <>
    {/* <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
        gap:"8px",
      }}
    >
      {dummyImageOptions.map((imageOption) => (
        <div
          key={imageOption.title}
          style={{    
       borderRadius:"8px",
        backgroundColor:"#f8fafc",
        alignItems:"center",
        justifyContent:"center",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, marginBottom: "0.5rem" }}
          >
            {imageOption.title}
          </Typography>

          <CameraImage
            image={currImage}
            setImage={(e) => handleDummyImageChange}
            currImage={imageOption.value}
            disable={false}
            removeButton={true}
            removeFunction={ handleRemoveFunction}
          />

          <Typography
            
            sx={{
              color: "grey",
              fontSize:"10px",
              marginTop: "0.3rem",
            }}
          >
            (*500px x 500px)
          </Typography>
        </div>
      ))}
    </div> */}

                                        <>
                                          <Typography color={"#606060"} marginTop={2}>
                                            Upload the image you wish to display when no image is available
                                            for the SKU
                                          </Typography>
                                          <div className="generic_form_container">
                                            <FeatureDropDown
                                              onChange={handleDummyImageChange}
                                              value={skuImageCatagory ?? "Beverages"}
                                              label={
                                                skuImageCatagory?.length === 0 ? "Select Category" : ""
                                              }
                                              name="defaultCatalogueImage"
                                              selectLableId=""
                                              placeholder="Select Dummy Image"
                                              options={dummyImageOptions.map(
                                                (imageOption) => imageOption.title
                                              )}
                                              size="small"
                                              sx={{
                                                minWidth: "32%",
                                                marginTop: "0.5rem",
                                                marginBottom: "1rem",
                                                borderRadius: "0%",
                                              }}
                                            />
                            
                                            <CameraImage
                                              image={image}
                                              setImage={setImage}
                                              currImage={currImage}
                                              disable={skuImageCatagory ? true : false}
                                              removeButton={true}
                                              removeFunction={handleRemoveFunction}
                                            />
                                          </div>
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                            }}
                                          >
                                            <Typography
                                              variant="caption"
                                              sx={{
                                                cursor: "pointer",
                                                color: "#00C6B1",
                                              }}
                                            >
                                              *The image resolution should be 500x500
                                            </Typography>
                                          </div>
                                        </>
                                  
  


    </>
  )
}
export const CatalogueConfigCustomLabels=(props:Props)=>{
  const [validationFailiure, setValidationFailiure] = useState<boolean>(false);

   const [labelCheckValueMapping, setLabelCheckValueMapping] = useState({
      caseLabel: {
        isChecked: props.values?.caseUnitLabel?.loadedFromApi === true,
        value: props.values?.caseUnitLabel?.loadedFromApi === true ? props.values?.caseUnitLabel?.value : props.values?.focCaseUnitLabel?.value,
      },
      packLabel: {
        isChecked: props.values?.packUnitLabel?.loadedFromApi === true,
        value: props.values?.packUnitLabel?.loadedFromApi === true ? props.values?.packUnitLabel?.value : props.values?.focPackUnitLabel?.value,
      },
      otherLabel: {
        isChecked: props.values?.otherUnitLabel?.loadedFromApi === true,
        value: props.values?.otherUnitLabel?.loadedFromApi === true ? props.values?.otherUnitLabel?.value : props.values?.focOtherUnitLabel?.value,
      },
    });
   
    
      useEffect(() => {
    
        setLabelCheckValueMapping({
          caseLabel: {
            isChecked: props.values?.caseUnitLabel?.loadedFromApi === true,
            value: props.values?.caseUnitLabel?.loadedFromApi === true ? props.values?.caseUnitLabel?.value : props.values?.focCaseUnitLabel?.value,
          },
          packLabel: {
            isChecked: props.values?.packUnitLabel?.loadedFromApi === true,
            value: props.values?.packUnitLabel?.loadedFromApi === true ? props.values?.packUnitLabel?.value : props.values?.focPackUnitLabel?.value,
          },
          otherLabel: {
            isChecked: props.values?.otherUnitLabel?.loadedFromApi === true,
            value: props.values?.otherUnitLabel?.loadedFromApi === true ? props.values?.otherUnitLabel?.value : props.values?.focOtherUnitLabel?.value,
          },
        });
      }, [
        props.values?.packUnitLabel,
        props.values?.focPackUnitLabel,
        props.values?.caseUnitLabel,
        props.values?.focCaseUnitLabel,
        props.values?.otherUnitLabel,
        props.values?.focOtherUnitLabel,
      ]);
    
     const handleLabelValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (
        e.target.value.match("^[a-zA-Z ]*$") == null &&
        e.target.type !== "number"
      ) {
        return;
      }
      if (e.target.type === "number") {
        const digit = e.target.value === "" ? 0 : Number(e.target.value);
        if (digit < 0) {
          openPopup("Error", "Cannot set a negative value");
          return;
        }
      }
  
      const keyName = e.target.name;
      if (keyName === "maxAllowedDigitForOrder") {
        const digit = e.target.value === "" ? 0 : Number(e.target.value); // Use Number to convert value
        if (digit > 4) {
          openPopup("Error", "You can select Upto 4 digits for order");
          return;
        }
      }
      props.setValues({
        ...props.values,
        [keyName]: {
          ...props.values[keyName],
          value: e.target.value,
          isValueUpdated: true,
          domainType: "catalogue_configuration",
        },
      });
      // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
      //   {
      //     ...values,
      //     [keyName]: {
      //       ...values[keyName],
      //       value: e.target.value,
      //       isValueUpdated: true,
      //       domainType: "catalogue_configuration",
      //     },
      //   },
      //   catalogueConfig,
      //   defaultCatalogueInputValues
      // );
      // setPlayGroundConfiguration(convertedVals);
    };
      const handleLabelUOMValueChange = (
        e: React.ChangeEvent<HTMLInputElement>
      ) => {
        const labelToConfigMapping: Record<
          string,
          { checked: string; unChecked?: string; ptrConfig: string } | undefined
        > = {
          caseLabel: {
            checked: "caseUnitLabel",
            unChecked: "focCaseUnitLabel",
            ptrConfig: "casePtrLabel",
          },
          packLabel: {
            checked: "packUnitLabel",
            unChecked: "focPackUnitLabel",
            ptrConfig: "packPtrLabel",
          },
          otherLabel: {
            checked: "otherUnitLabel",
            unChecked: "focOtherUnitLabel",
            ptrConfig: "otherPtrLabel",
          },
        };
    
        const labelName = e.target.name as "caseLabel" | "packLabel" | "otherLabel";
        const value = e.target.value;
    
        if (
          e.target.value.match("^[a-zA-Z ]*$") == null &&
          e.target.type !== "number"
        ) {
          return;
        }
        if (e.target.type === "number") {
          const digit = e.target.value === "" ? 0 : Number(e.target.value);
          if (digit < 0) {
            openPopup("Error", "Cannot set a negative value");
            return;
          }
        }
    
        const configMapping = labelToConfigMapping[labelName];
    
        if (configMapping) {
          props.setValues((prev:any) => {
            const checkedConfig = configMapping.checked;
            const unCheckedConfig = configMapping.unChecked;
            const ptrConfig = configMapping.ptrConfig;
    
            if (labelCheckValueMapping[labelName].isChecked) {
              prev[checkedConfig] = {
                ...prev[checkedConfig],
                value,
                isValueUpdated: true,
                domainType: "catalogue_configuration",
              };
            } else {
              if (unCheckedConfig) {
                prev[unCheckedConfig] = {
                  ...prev[unCheckedConfig],
                  value,
                  isValueUpdated: true,
                  domainType: "catalogue_configuration",
                };
              }
            }
    
            prev[ptrConfig] = {
              ...prev[ptrConfig],
              value: `per ${value}`,
              isValueUpdated: true,
              domainType: "catalogue_configuration",
            };
    
            return { ...prev };
          });
    
          // const { result: convertedVals, failedValidations }  = convertValuesToConfigNew(
          //   values,
          //   catalogueConfig,
          //   defaultCatalogueInputValues
          // );
          // setPlayGroundConfiguration(convertedVals);
        }
      };
  return(
  
  
                                                  <>
                                                   <div style={{ display: "grid",color:"grey",fontSize:"11px",
    gridTemplateColumns: "repeat(3, 1fr)", 
    gap: "8px"}}>
      <div style={{display:"flex",flexDirection:"column"}} >
          <div >
            UOM 1
          </div>
          <Input
          value={labelCheckValueMapping["caseLabel"].value}
           onChange={handleLabelUOMValueChange}
           inputProps={{max:5,min:3}}
           name={"caseLabel"}
           sx={{
    "& .MuiInputBase-input": {
      color: "#808080", 
    },
    fontSize:"12px",
  }}
          />                                
      </div>
       <div style={{display:"flex",flexDirection:"column"}} >
          <div>
            UOM 2
          </div>
          <Input
          value={labelCheckValueMapping["packLabel"].value}
           onChange={handleLabelUOMValueChange}
           inputProps={{max:5,min:3}}
           name={"packLabel"}
            sx={{
    "& .MuiInputBase-input": {
      color: "#808080", 
      
    },
    fontSize:"12px",
  }}
          />                                
      </div>
       <div style={{display:"flex",flexDirection:"column"}} >
          <div>
            UOM 3
          </div>
          <Input
          value={labelCheckValueMapping["otherLabel"].value}
           onChange={handleLabelUOMValueChange}
           inputProps={{max:5,min:3}}
           name={"otherLabel"}
               sx={{
    "& .MuiInputBase-input": {
      color: "#808080",   
    },
    fontSize:"12px",
  }}
          />                                
      </div>
       <div style={{display:"flex",flexDirection:"column"}} >
          <div>
            MRP
          </div>
          <Input
          value={props.values?.mrpLabel?.value}
           onChange={handleLabelValueChange}
           inputProps={{max:11,min:3}}
           name={"mrpLabel"}
               sx={{
    "& .MuiInputBase-input": {
      color: "#808080",  
    },
    fontSize:"12px",
  }}
          />                                
      </div>
       <div style={{display:"flex",flexDirection:"column"}} >
          <div>
            Similar Product 
          </div>
          <Input
          value={props.values?.multiVariantHeader?.value}
           onChange={handleLabelValueChange}
           inputProps={{max:25,min:3}}
           name={"multiVariantHeader"}
               sx={{
    "& .MuiInputBase-input": {
      color: "#808080",  
    },
    fontSize:"12px",
  }}
          />                                
      </div>
{/*       
                                                    <FlexInputLabel
                                                      label="UOM 1 :"
                                                      name={"caseLabel"}
                                                      value={labelCheckValueMapping["caseLabel"].value}
                                                      onChange={handleLabelUOMValueChange}
                                                      placeholder=""
                                                      max={5}
                                                      min={3}
                                                      onValidationFailiure={setValidationFailiure}
                                                    />
                                                    <FlexInputLabel
                                                      label="UOM 2 :"
                                                      name={"packLabel"}
                                                      value={labelCheckValueMapping["packLabel"].value}
                                                      onChange={handleLabelUOMValueChange}
                                                      placeholder=""
                                                      max={5}
                                                      min={3}
                                                      onValidationFailiure={setValidationFailiure}
                                                    /> */}
                                                    {/* <FlexInputLabel
                                                      label="UOM 3 :"
                                                      name={"otherLabel"}
                                                      value={labelCheckValueMapping["otherLabel"].value}
                                                      onChange={handleLabelUOMValueChange}
                                                      placeholder=""
                                                      max={5}
                                                      min={3}
                                                      onValidationFailiure={setValidationFailiure}
                                                    /> */}
                                                    {/* <FlexInputLabel
                                                      label="MRP :"
                                                      name={"mrpLabel"}
                                                      value={props.values?.mrpLabel?.value}
                                                      onChange={handleLabelValueChange}
                                                      placeholder=""
                                                      max={11}
                                                      min={3}
                                                      onValidationFailiure={setValidationFailiure}
                                                    /> */}
                                                    {/* multi variant */}
                                                    {/* <FlexInputLabel
                                                      label="Similar Product :"
                                                      name={"multiVariantHeader"}
                                                      value={props.values?.multiVariantHeader?.value}
                                                      onChange={handleLabelValueChange}
                                                      placeholder=""
                                                      max={25}
                                                      min={3}
                                                      onValidationFailiure={setValidationFailiure} 
                                                    /> */}
                                                    </div>
                                                  </>

                                           

  )
}
export const CatalogueConfigCustomPriceFormatted=(props:Props)=>{
  const handleDecimalChange = (e: SelectChangeEvent<unknown>,checked:boolean) => {
      const keyName = e.target.name;
      let newVal = "";
      if (props.values?.priceFormatter?.value.split("-")[1] === "ROUND_OFF") {
        newVal = props.values?.priceFormatter?.value.split("-")[0] + "-WITHOUT_ROUND_OFF";
        props.setValues({
          ...props.values,
          [keyName]: {
            ...props.values[keyName],
            value: newVal,
            isValueUpdated: true,
            domainType: "catalogue_configuration",
          },
        });
      } else {
        newVal = props.values?.priceFormatter?.value.split("-")[0] + "en_US-ROUND_OFF";
        props.setValues({
          ...props.values,
          [keyName]: {
            ...props.values[keyName],
            value: newVal,
            isValueUpdated: true,
            domainType: "catalogue_configuration",
          },
        });
      }
    };

  return(
    <>
    <div style={{display:"flex",gap:"8px",alignItems:"center"}} >
<Typography color={"#000000"} >
                  Do you want to show price with decimal ?
                </Typography>
                <div style={{ display: "flex", gap: "2vw" }}>
                  <DashboardToggleSwitch
                    value={true}
                    checked={
                      props.values?.priceFormatter?.value.split("-")[1] !== "ROUND_OFF"
                    }
                    onChange={(e,checked)=>handleDecimalChange(e,checked)}
                    name="priceFormatter"
                    label="Yes"
                  />
                  </div>
                  </div>
                  
    </>
  )
}

